import axios from 'axios';
import myVMUrl from './config/myVMUrl';

export const origin = (() => {
  const browserOrigin = window.location.origin;
  if (browserOrigin === 'http://localhost:3000') {
    return myVMUrl;
  }
  return browserOrigin;
})();

export const axiosInstance = axios.create({
  baseURL: `${origin}/services`,
  withCredentials: true
});

export const isPWA = window.matchMedia('(display-mode: standalone)').matches;

export const trackingCode = (_ => {
  if (window.location.href.includes('ssl-dev')) return 'UA-145148-3';
  if (window.location.href.includes('/epe')) return 'UA-145148-2';
  if (window.location.href.includes('/gpc')) return 'UA-145148-4';
  return '';
})();
